/* mwy v2 */

/* Inline selected SVG drawer icons so their artwork can follow the live header
   color (or an exact custom color) without relying on cross-origin CSS masks. */
(function initNavigationTriggerArtwork() {
  var navigationIconInstance = 0;

  function namespaceSvgIds(svg) {
    if (svg.hasAttribute('data-mwy-svg-prepared')) return;
    navigationIconInstance += 1;
    var prefix = 'mwy-nav-icon-' + navigationIconInstance + '-';
    var idMap = {};

    svg.querySelectorAll('[id]').forEach(function(node) {
      var oldId = node.id;
      var newId = prefix + oldId;
      idMap[oldId] = newId;
      node.id = newId;
    });

    if (!Object.keys(idMap).length) {
      svg.setAttribute('data-mwy-svg-prepared', 'true');
      return;
    }

    svg.querySelectorAll('*').forEach(function(node) {
      Array.from(node.attributes || []).forEach(function(attribute) {
        var value = attribute.value;
        Object.keys(idMap).forEach(function(oldId) {
          var escapedId = oldId.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
          value = value.replace(new RegExp('url\\(["\\\']?#' + escapedId + '["\\\']?\\)', 'g'), 'url(#' + idMap[oldId] + ')');
          if (value === '#' + oldId) value = '#' + idMap[oldId];
        });
        if (value !== attribute.value) node.setAttribute(attribute.name, value);
      });
    });

    svg.setAttribute('data-mwy-svg-prepared', 'true');
  }

  /* Shared preparation path for any editable SVG that must be inserted inline. */
  window.mwyPrepareInlineSvg = function(svg) {
    if (!svg || svg.nodeName.toLowerCase() !== 'svg') return svg;
    svg.querySelectorAll('script, foreignObject').forEach(function(node) { node.remove(); });
    namespaceSvgIds(svg);
    return svg;
  };

  function declaredSvgPaint(shape, property, svg) {
    var node = shape;
    var pattern = new RegExp('(?:^|;)\\s*' + property + '\\s*:\\s*([^;]+)', 'i');

    while (node && node !== svg) {
      var inlineStyle = node.getAttribute('style') || '';
      var styleMatch = inlineStyle.match(pattern);
      if (styleMatch) return styleMatch[1].trim();

      var attribute = node.getAttribute(property);
      if (attribute !== null) return attribute.trim();
      node = node.parentElement;
    }

    return null;
  }

  function recolorSvg(svg, colorValue) {
    svg.querySelectorAll('path, circle, ellipse, rect, line, polyline, polygon').forEach(function(shape) {
      /* Definitions describe clipping, masks, gradients, and reusable geometry;
         they are not visible artwork and must retain their original paint. */
      if (shape.closest('defs, clipPath, mask, symbol, pattern, marker, filter, linearGradient, radialGradient')) return;

      var fill = declaredSvgPaint(shape, 'fill', svg);
      var stroke = declaredSvgPaint(shape, 'stroke', svg);
      var hasFill = fill !== null && fill.toLowerCase() !== 'none';
      var hasStroke = stroke !== null && stroke.toLowerCase() !== 'none';

      if (hasFill || (fill === null && !hasStroke)) {
        shape.style.setProperty('fill', colorValue, 'important');
      } else if (hasStroke) {
        /* An omitted fill on stroke artwork must not fall back to SVG's
           default black fill when inserted inline. */
        shape.style.setProperty('fill', 'none', 'important');
      }

      if (hasStroke) {
        shape.style.setProperty('stroke', colorValue, 'important');
      }
    });
  }

  function hydrateNavigationIcons(root) {
    (root || document).querySelectorAll('img.mwy-nav-trigger-icon--artwork:not([data-mwy-svg-checked])').forEach(function(image) {
      image.setAttribute('data-mwy-svg-checked', 'true');
      var source = image.currentSrc || image.src;
      var colorMode = image.getAttribute('data-mwy-menu-icon-color') || 'theme';
      var colorValue = image.getAttribute('data-mwy-menu-icon-color-value') || 'var(--mwy-header-logo-color, var(--colorBtnPrimary, #8a542f))';
      if (colorMode === 'original' || !/\.svg(?:\?|$)/i.test(source)) return;

      fetch(source)
        .then(function(response) {
          if (!response.ok) throw new Error('Unable to load menu SVG');
          return response.text();
        })
        .then(function(markup) {
          var parsed = new DOMParser().parseFromString(markup, 'image/svg+xml');
          var svg = parsed.documentElement;
          if (!svg || svg.nodeName.toLowerCase() !== 'svg') return;

          window.mwyPrepareInlineSvg(svg);
          svg.removeAttribute('width');
          svg.removeAttribute('height');
          svg.setAttribute('aria-hidden', 'true');
          svg.setAttribute('focusable', 'false');
          svg.setAttribute('class', image.getAttribute('class') + ' mwy-nav-trigger-icon--svg');
          svg.setAttribute('style', image.getAttribute('style') || '');
          recolorSvg(svg, colorValue);
          image.replaceWith(document.importNode(svg, true));
        })
        .catch(function() {
          /* Keep the original image as a safe fallback if an SVG cannot load. */
        });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() { hydrateNavigationIcons(document); });
  } else {
    hydrateNavigationIcons(document);
  }

  document.addEventListener('shopify:section:load', function(event) {
    hydrateNavigationIcons(event.target);
  });
})();

/* The desktop homepage and Store artwork turn continuously. A click eases through
   the configured partial revolution, then reverses the ongoing direction.
   Other navigation triggers retain the established open/close turn. */
(function initNavigationTriggerSpin() {
  var ambientStates = new WeakMap();
  var ambientTriggers = [];
  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  var desktopMotion = window.matchMedia('(min-width: 769px)');
  var ambientVisibility = 'IntersectionObserver' in window ? new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      var state = ambientStates.get(entry.target);
      if (state) { state.visible = entry.isIntersecting; syncAmbientMotion(state); }
    });
  }) : null;

  function cssDuration(element, property, fallback) {
    var value = getComputedStyle(element).getPropertyValue(property).trim();
    if (!value) return fallback;
    var number = parseFloat(value);
    if (!Number.isFinite(number)) return fallback;
    return value.endsWith('ms') ? number : number * 1000;
  }

  function cssNumber(element, property, fallback) {
    var value = parseFloat(getComputedStyle(element).getPropertyValue(property));
    return Number.isFinite(value) ? value : fallback;
  }

  function ambientIcon(trigger) {
    return trigger && trigger.querySelector('.mwy-nav-trigger-icon-motion--ambient .mwy-nav-trigger-icon');
  }

  function ensureAmbientState(trigger) {
    if (!trigger ||
        (!trigger.classList.contains('mwy-desktop-home-toggle') && !trigger.classList.contains('mwy-commerce-desktop-toggle')) ||
        !ambientIcon(trigger) || !ambientIcon(trigger).animate) return null;
    var state = ambientStates.get(trigger);
    if (state) return state;
    state = {
      trigger: trigger,
      icon: ambientIcon(trigger),
      visible: !ambientVisibility,
      angle: 0,
      direction: 1,
      animation: null,
      revolutionDuration: cssDuration(trigger.querySelector('.mwy-nav-trigger-icon-motion'), '--mwy-nav-trigger-idle-duration', 60000),
      burst: null
    };
    ambientStates.set(trigger, state);
    if (ambientVisibility) ambientVisibility.observe(trigger);
    ambientTriggers.push(trigger);
    syncAmbientMotion(state);
    return state;
  }

  function easeInOutCubic(progress) {
    return progress < 0.5
      ? 4 * progress * progress * progress
      : 1 - Math.pow(-2 * progress + 2, 3) / 2;
  }

  function rotation(angle) { return 'rotate(' + angle + 'deg)'; }

  // Browser-owned transform animations can continue without a JavaScript
  // callback/style write on every frame. Read their clock only on interaction.
  function currentAngle(state) {
    var time = state.animation ? Number(state.animation.currentTime) || 0 : 0;
    if (state.burst) {
      var progress = Math.min(1, Math.max(0, time / state.burst.duration));
      // Match the sampled click keyframes even when interrupted mid-turn.
      var sample = progress * 32, lower = Math.floor(sample), blend = sample - lower;
      var eased = easeInOutCubic(lower / 32) * (1 - blend) + easeInOutCubic(Math.min(32, lower + 1) / 32) * blend;
      return state.angle + state.burst.direction * state.burst.angle * eased;
    }
    return state.angle - state.direction * 360 * time / Math.max(1000, state.revolutionDuration * 2);
  }

  function stopAmbientMotion(state) {
    if (!state.animation) return;
    state.angle = currentAngle(state) % 360;
    state.icon.style.transform = rotation(state.angle);
    state.animation.onfinish = null;
    state.animation.cancel();
    state.animation = null;
    state.burst = null;
  }

  function syncAmbientMotion(state) {
    var shouldPlay = state.trigger.isConnected && state.visible && desktopMotion.matches && !document.hidden && !reducedMotion.matches;
    if (!shouldPlay) {
      if (state.animation && state.animation.playState !== 'paused') state.animation.pause();
      return;
    }
    if (!state.animation) {
      state.animation = state.icon.animate([
        { transform: rotation(state.angle) },
        { transform: rotation(state.angle - state.direction * 360) }
      ], { duration: Math.max(1000, state.revolutionDuration * 2), iterations: Infinity, easing: 'linear' });
    } else if (state.animation.playState === 'paused') {
      state.animation.play();
    }
  }

  function startAmbientIcons(root) {
    (root || document).querySelectorAll('.mwy-desktop-home-toggle, .mwy-commerce-desktop-toggle').forEach(ensureAmbientState);
  }

  function burstAmbientIcon(trigger) {
    var state = ensureAmbientState(trigger);
    if (!state) return false;
    if (reducedMotion.matches) {
      state.direction *= -1;
      return true;
    }
    stopAmbientMotion(state);
    var burst = state.burst = {
      direction: -state.direction,
      duration: cssDuration(trigger, '--mwy-nav-trigger-spin-duration', 1800) * 2,
      angle: cssNumber(trigger, '--mwy-nav-trigger-click-angle', 72)
    };
    // Sample the existing cubic timing once per click, not once per frame.
    var frames = Array.from({ length: 33 }, function(_, index) {
      return { offset: index / 32, transform: rotation(state.angle + burst.direction * burst.angle * easeInOutCubic(index / 32)) };
    });
    var animation = state.animation = state.icon.animate(frames, { duration: burst.duration, easing: 'linear', fill: 'forwards' });
    animation.onfinish = function() {
      if (state.animation !== animation) return;
      state.direction = burst.direction;
      stopAmbientMotion(state);
      syncAmbientMotion(state);
    };
    syncAmbientMotion(state);
    return true;
  }

  function spinNavigationTrigger(trigger, direction) {
    if (!desktopMotion.matches && trigger && trigger.querySelector('.mwy-nav-trigger-mobile-hamburger')) return;
    var icon = trigger && trigger.querySelector('.mwy-nav-trigger-icon');
    if (!icon) return;
    if (burstAmbientIcon(trigger)) return;

    trigger.classList.remove('mwy-nav-trigger--spinning-forward', 'mwy-nav-trigger--spinning-reverse');
    trigger.classList.toggle('mwy-nav-trigger--open', direction !== 'reverse');
    void trigger.offsetWidth;
    trigger.classList.add(direction === 'reverse' ? 'mwy-nav-trigger--spinning-reverse' : 'mwy-nav-trigger--spinning-forward');

    icon.addEventListener('animationend', function clearSpin() {
      trigger.classList.remove('mwy-nav-trigger--spinning-forward', 'mwy-nav-trigger--spinning-reverse');
    }, { once: true });
  }

  window.mwySpinNavigationTrigger = spinNavigationTrigger;

  function spinNavigationTriggers() {
    document.querySelectorAll('.js-drawer-open-nav').forEach(function(trigger) {
      spinNavigationTrigger(trigger, 'forward');
    });
  }

  document.addEventListener('drawerOpen.NavDrawer', spinNavigationTriggers);

  function watchNavigationDrawer() {
    var drawer = document.getElementById('NavDrawer');
    if (!drawer) return;
    var wasOpen = drawer.classList.contains('drawer--is-open');

    new MutationObserver(function() {
      var isOpen = drawer.classList.contains('drawer--is-open');
      if (wasOpen && !isOpen) {
        document.querySelectorAll('.js-drawer-open-nav').forEach(function(trigger) {
          spinNavigationTrigger(trigger, 'reverse');
        });
      }
      wasOpen = isOpen;
    }).observe(drawer, { attributes: true, attributeFilter: ['class'] });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      startAmbientIcons(document);
      watchNavigationDrawer();
    });
  } else {
    startAmbientIcons(document);
    watchNavigationDrawer();
  }

  document.addEventListener('shopify:section:load', function(event) {
    startAmbientIcons(event.target);
  });

  document.addEventListener('shopify:section:unload', function(event) {
    ambientTriggers = ambientTriggers.filter(function(trigger) {
      if (!event.target.contains(trigger)) return true;
      stopAmbientMotion(ambientStates.get(trigger));
      if (ambientVisibility) ambientVisibility.unobserve(trigger);
      ambientStates.delete(trigger);
      return false;
    });
  });

  function resumeVisibleMotion() {
    ambientTriggers.forEach(function(trigger) {
      var state = ambientStates.get(trigger);
      if (state) syncAmbientMotion(state);
    });
  }
  desktopMotion.addEventListener('change', resumeVisibleMotion);
  document.addEventListener('visibilitychange', resumeVisibleMotion);
  window.addEventListener('pageshow', resumeVisibleMotion);

  reducedMotion.addEventListener('change', function() {
    if (reducedMotion.matches) {
      ambientTriggers.forEach(function(trigger) {
        var state = ambientStates.get(trigger);
        var icon = ambientIcon(trigger);
        if (state) { stopAmbientMotion(state); state.angle = 0; }
        if (icon) icon.style.transform = '';
      });
    } else {
      resumeVisibleMotion();
    }
  });
})();


/* =========================
   MWY – site scripts (clean drop-in)
   ========================= */

(() => {
  'use strict';

  /* -------------------------
   * Config
   * ------------------------- */
  var FREE_SHIPPING_THRESHOLD = 75.0;
  var MOBILE_MAX = 990; // Motion mobile breakpoint
  var IDS = {
    freeMsg: 'free-shipping-message',
    freeMsgDrawer: 'free-shipping-message-drawer',
    usBanner: 'us-shipping-banner',
    navDrawer: 'NavDrawer',
  };
  /* -------------------------
   * Helpers
   * ------------------------- */
  var isUS = () => typeof Shopify !== 'undefined' && Shopify.country === 'US';
  var $ = (sel, root = document) => root.querySelector(sel);
  var $$ = (sel, root = document) => Array.from(root.querySelectorAll(sel));
  var fetchCart = () => fetch('/cart.js').then((r) => r.json());

  /* -------------------------
   * Free shipping messages
   * ------------------------- */
  async function updateFreeShippingMessage() {
    var msgEl = document.getElementById(IDS.freeMsg);
    var bannerEl = document.getElementById(IDS.usBanner);
    if (!msgEl && !bannerEl) return; // nothing to do

    // Non-US: hide all shipping promos
    if (!isUS()) {
      if (msgEl) msgEl.style.display = 'none';
      if (bannerEl) bannerEl.style.display = 'none';
      return;
    }

    try {
      var cart = await fetchCart();
      var subtotal = (cart.total_price || 0) / 100;
      var diff = Math.max(0, FREE_SHIPPING_THRESHOLD - subtotal).toFixed(2);

      if (cart.item_count > 0) {
        // Hide default banner; show dynamic message
        if (bannerEl) bannerEl.style.display = 'none';
        if (msgEl) {
          msgEl.style.display = 'block';
          if (subtotal >= FREE_SHIPPING_THRESHOLD) {
            msgEl.innerHTML = '✅ You Qualified for <em>FREE</em> shipping!';
          } else {
            msgEl.innerHTML = `📦 You're <strong>$${diff}</strong> away from <em>FREE</em> shipping!`;
          }
        }
      } else {
        // Empty cart: show default banner; hide dynamic message
        if (bannerEl) bannerEl.style.display = 'block';
        if (msgEl) msgEl.style.display = 'none';
      }
    } catch (err) {
      console.error('Free shipping (cart page) error:', err);
    }
  }

  async function updateFreeShippingMessageDrawer() {
    var el = document.getElementById(IDS.freeMsgDrawer);
    if (!el) return;

    if (!isUS()) {
      el.style.display = 'none';
      return;
    }

    el.style.display = 'block';
    try {
      var cart = await fetchCart();
      var subtotal = (cart.total_price || 0) / 100;
      var diff = Math.max(0, FREE_SHIPPING_THRESHOLD - subtotal).toFixed(2);

      if (subtotal >= FREE_SHIPPING_THRESHOLD) {
        el.innerHTML = '✅ You Qualified for <em>FREE</em> shipping!';
      } else {
        el.innerHTML = `📦 You're <strong>$${diff}</strong> away from <em>FREE</em> shipping!`;
      }
    } catch (err) {
      console.error('Free shipping (drawer) error:', err);
    }
  }

  
  /* -------------------------
   * Cart-related event wiring
   * ------------------------- */
  function wireCartEvents() {
    // Initial load
    updateFreeShippingMessage();
    updateFreeShippingMessageDrawer();

    // After +/- quantity clicks
    document.addEventListener('click', (e) => {
      if (!e.target.closest('.qty__adjust')) return;
      setTimeout(() => {
        updateFreeShippingMessage();
        updateFreeShippingMessageDrawer();
      }, 500);
    });

    // When any "open drawer" control is clicked, refresh the drawer message
    document.addEventListener('click', (e) => {
      var opener = e.target.closest('[data-action="open-drawer"], [aria-controls="CartDrawer"], [data-drawer-id="CartDrawer"]');
      if (!opener) return;
      // Refresh after drawer animation
      setTimeout(updateFreeShippingMessageDrawer, 500);
    });

    // After product is added via AJAX or on cart form submit
    document.addEventListener('submit', (e) => {
      var addForm = e.target.closest('form[action^="/cart/add"]');
      if (addForm) {
        setTimeout(() => {
          updateFreeShippingMessage();
          updateFreeShippingMessageDrawer();
        }, 800);
      }

      var cartForm = e.target.closest('form[action="/cart"]');
      if (cartForm) {
        setTimeout(() => {
          updateFreeShippingMessage();
          updateFreeShippingMessageDrawer();
        }, 800);
      }
    });

    // Watch subtotal DOM updates on the cart page
    var subtotalEl = document.querySelector('[data-subtotal]');
    if (subtotalEl) {
      var observer = new MutationObserver(() => {
        updateFreeShippingMessage();
        updateFreeShippingMessageDrawer();
      });
      observer.observe(subtotalEl, { characterData: true, childList: true, subtree: true });
    }
  }

  /* -------------------------
   * Init
   * ------------------------- */
  function init() {
    wireCartEvents();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* -------------------------
 * MOBILE NAV (Motion) — auto-expand first level when #NavDrawer opens
 * Self-contained; does not depend on the code above.
 * ------------------------- */
(() => {
  var MOBILE_MAX = 990;                // adjust if your mobile breakpoint differs
  var NAV_ID = 'NavDrawer';
  var $$ = (sel, root = document) => Array.from(root.querySelectorAll(sel));

  function isVisible(el) {
    if (!el) return false;
    if (el.getAttribute('aria-hidden') === 'true') return false;
    var r = el.getBoundingClientRect();
    return r.width > 0 && r.height > 0;
  }

  function expandFirstLevel(drawer) {
    if (!drawer || window.innerWidth > MOBILE_MAX) return;
    var toggles = $$('.mobile-nav > li .collapsible-trigger[aria-controls^="Linklist-"]', drawer);
    toggles.forEach(btn => {
      if (btn.getAttribute('aria-expanded') !== 'true') btn.click(); // use theme's own handler
    });
    drawer.dataset._autoExpanded = '1';
  }

  function onPossibleOpen() {
    var drawer = document.getElementById(NAV_ID);
    if (!drawer) return;
    if (isVisible(drawer) && drawer.dataset._autoExpanded !== '1') expandFirstLevel(drawer);
    if (!isVisible(drawer)) delete drawer.dataset._autoExpanded;
  }

  function init() {
    var drawer = document.getElementById(NAV_ID);
    if (!drawer) return;

    // Try immediately (theme editor cases)
    onPossibleOpen();

    // Observe drawer attribute/class changes
    var mo = new MutationObserver(onPossibleOpen);
    mo.observe(drawer, { attributes: true, attributeFilter: ['class', 'style', 'aria-hidden'] });

    // Some builds toggle classes on <html>
    var moRoot = new MutationObserver(onPossibleOpen);
    moRoot.observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });

    // Also react when open buttons are clicked
    document.addEventListener('click', (e) => {
      if (e.target.closest('[aria-controls="NavDrawer"], [data-drawer-id="NavDrawer"], [href="#NavDrawer"]')) {
        setTimeout(onPossibleOpen, 50);
      }
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();

/* =====================================================
   Footer section headings
   — Menu columns: reads title from data-mwy-menu-title (set in footer.liquid)
   — Newsletter column: reads from collapsible trigger button text
   ===================================================== */
(function() {
  function _mwyFooterHeadings() {
    // Menu columns: read Shopify menu title from data attribute
    var menus = document.querySelectorAll('footer .grid__item[data-mwy-menu-title]');
    menus.forEach(function(col) {
      if (col.querySelector('.mwy-menu-heading')) return;
      var title = col.getAttribute('data-mwy-menu-title');
      if (!title) return;
      var h = document.createElement('h2');
      h.className = 'footer__title mwy-menu-heading';
      h.textContent = title;
      col.insertBefore(h, col.firstChild);
    });

    // Newsletter column: use the Shopify-rendered trigger button text
    var newsletter = document.querySelector('footer .grid-newsletter');
    if (newsletter && !newsletter.querySelector('.mwy-menu-heading')) {
      var btn = newsletter.querySelector('.collapsible-trigger-btn');
      var title = btn ? btn.childNodes[0].textContent.trim() : 'Mailing List';
      var h = document.createElement('h2');
      h.className = 'footer__title mwy-menu-heading';
      h.textContent = title;
      newsletter.insertBefore(h, newsletter.firstChild);
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', _mwyFooterHeadings);
  } else {
    _mwyFooterHeadings();
  }
})();

/* =====================================================
   Newsletter subscribe: success modal
   Replaces inline "Thanks for subscribing" with a
   branded modal overlay.
   ===================================================== */
(function() {
  function _mwySubscribeModal() {
    var successNote = document.querySelector('#newsletter-footer .note--success');
    if (!successNote) return;

    // Hide the inline success message
    successNote.style.display = 'none';

    // Build modal
    var overlay = document.createElement('div');
    overlay.className = 'mwy-subscribe-modal';
    overlay.innerHTML =
      '<div class="mwy-subscribe-modal__card">' +
        '<p class="mwy-subscribe-modal__title">Thank you for joining<br>our mailing list.</p>' +
        '<button class="mwy-subscribe-modal__btn">You’re Welcome</button>' +
      '</div>';
    document.body.appendChild(overlay);

    // Animate in (double rAF ensures transition fires)
    requestAnimationFrame(function() {
      requestAnimationFrame(function() {
        overlay.classList.add('is-open');
      });
    });

    function closeModal() {
      overlay.classList.remove('is-open');
      setTimeout(function() { if (overlay.parentNode) overlay.parentNode.removeChild(overlay); }, 350);
    }

    overlay.querySelector('.mwy-subscribe-modal__btn').addEventListener('click', closeModal);
    overlay.addEventListener('click', function(e) {
      if (e.target === overlay) closeModal();
    });
    document.addEventListener('keydown', function onKey(e) {
      if (e.key === 'Escape') { closeModal(); document.removeEventListener('keydown', onKey); }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', _mwySubscribeModal);
  } else {
    _mwySubscribeModal();
  }
})();

/* Desktop LIVE dropdown: open on hover instead of click */
(function() {
  if (window.innerWidth < 750) return;
  var details = document.querySelector('.site-nav__details');
  if (!details) return;
  var summary = details.querySelector('summary');
  var closeTimer = null;

  // Prevent click from toggling (only hover should control it)
  summary.addEventListener('click', function(e) {
    e.preventDefault();
  });

  details.addEventListener('mouseenter', function() {
    if (closeTimer) { clearTimeout(closeTimer); closeTimer = null; }
    details.setAttribute('open', '');
  });

  details.addEventListener('mouseleave', function() {
    closeTimer = setTimeout(function() {
      details.removeAttribute('open');
    }, 200);
  });
})();


/* Desktop: hovering the logo also opens the LIVE dropdown */
(function() {
  function initLogoDropdown() {
    var logo = document.querySelector('#LogoContainer');
    var details = document.querySelector('#site-nav-item--1');
    var summary = details ? details.querySelector('summary') : null;
    if (!logo || !details || !summary) return;

    var closeTimer = null;
    var isClosing = false;

    function openDropdown() {
      clearTimeout(closeTimer);
      if (isClosing) {
        isClosing = false;
        details.classList.remove('is-closing');
      }
      details.setAttribute('open', '');
      summary.setAttribute('aria-expanded', 'true');
    }

    function animateClose() {
      if (!details.hasAttribute('open')) return;
      closeTimer = setTimeout(function() {
        isClosing = true;
        details.classList.add('is-closing');
        setTimeout(function() {
          details.removeAttribute('open');
          summary.setAttribute('aria-expanded', 'false');
          details.classList.remove('is-closing');
          isClosing = false;
        }, 450);
      }, 150);
    }

    function cancelClose() {
      clearTimeout(closeTimer);
      if (isClosing) {
        isClosing = false;
        details.classList.remove('is-closing');
      }
    }

    logo.addEventListener('mouseenter', openDropdown);
    logo.addEventListener('mouseleave', animateClose);
    details.addEventListener('mouseenter', cancelClose);
    details.addEventListener('mouseleave', animateClose);

    /* Also handle native hover on the summary/LIVE text */
    summary.addEventListener('click', function(e) {
      e.preventDefault();
      if (details.hasAttribute('open') && !isClosing) {
        animateClose();
      } else {
        openDropdown();
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initLogoDropdown);
  } else {
    initLogoDropdown();
  }
})();

(function _mwyAuctionInit() {
  var ATTEMPTS = 0; var MAX = 60;

  function splitBidAmount(el) {
    var amountEl = el.querySelector('#_a-current-bid');
    var num;

    if (amountEl) {
      // After-bid state: AP injects #_a-current-bid + #_a-bids inside the span
      var raw = amountEl.textContent.replace(/\$/g, '').replace(/,/g, '').trim();
      num = raw.split('.')[0].trim();
      if (!num || isNaN(parseInt(num, 10))) return;
      // Style just the amount element, leave #_a-bids untouched
      amountEl.innerHTML = '<span class="mwy-amt"><span class="mwy-cur">$<\/span>' + num + '<\/span>';
      // Hide the 'Current bid: ' label span (we use data-bid-label ::before instead)
      var labelSpan = el.querySelector(':scope > span:not(.mwy-amt)');
      if (labelSpan) labelSpan.style.display = 'none';
    } else {
      // Starting bid state: plain text 'Starting bid: $ 150.00'
      var raw = el.textContent.trim();
      var colonIdx = raw.indexOf(':');
      if (colonIdx > -1) raw = raw.substring(colonIdx + 1).trim();
      raw = raw.replace(/\$/g, '').replace(/,/g, '').trim();
      num = raw.split('.')[0].trim();
      if (!num || isNaN(parseInt(num, 10))) return;
      el.innerHTML = '<span class="mwy-amt"><span class="mwy-cur">$<\/span>' + num + '<\/span>';
    }
  }

  function initLabel(el) {
    var hasCurrent = el.querySelector('#_a-current-bid') !== null;
    var isCurrent = hasCurrent || el.textContent.toLowerCase().indexOf('current') > -1;
    el.setAttribute('data-bid-label', isCurrent ? 'CURRENT BID' : 'STARTING BID');
  }

  var interval = setInterval(function() {
    ATTEMPTS++;
    if (ATTEMPTS > MAX) { clearInterval(interval); return; }
    var visible = document.querySelector('._a-auction-input-container > span._a-current-bid-font:not(._a-hide)');
    if (!visible || visible.textContent.indexOf('$') === -1) return;
    clearInterval(interval);

    var isMobile = window.innerWidth < 750;

    // 1. Placeholder
    var bidInput = document.getElementById('_a-bid-input');
    if (bidInput) bidInput.setAttribute('placeholder', 'Your bid amount');

    // 2. ENTER button
    var bidBtn = document.getElementById('_a-bid-btn');
    if (bidBtn) bidBtn.textContent = 'Enter Bid';

    // 3. Place Auto Bid
    var autoBid = document.getElementById('_a-auto-bid');
    if (autoBid) { var lbl = autoBid.querySelector('b'); if (lbl) lbl.textContent = 'Place Auto Bid'; }

    // 4. Watch This Auction
    var wl = document.getElementById('_a-btn-watchlist');
    if (wl) { var wlT = wl.querySelector('._a-btn-watchlist-text'); if (wlT) wlT.textContent = 'Watch This Auction'; }

    // 5. Bid label + split amount
    initLabel(visible);
    splitBidAmount(visible);

    // 6. Watch for AP updating the span (new bid placed)
    if (!visible._mwyAmtObs) {
      visible._mwyAmtObs = new MutationObserver(function() {
        visible._mwyAmtObs.disconnect();
        initLabel(visible);
        if (!visible.querySelector('.mwy-amt')) splitBidAmount(visible);
        else if (visible.querySelector('#_a-current-bid:not(:has(.mwy-amt))')) splitBidAmount(visible);
        visible._mwyAmtObs.observe(visible, { childList: true, subtree: true });
      });
      visible._mwyAmtObs.observe(visible, { childList: true, subtree: true });
    }

    // 6b. Container observer — catches span replacement when AP processes a new bid
    var bidContainer = visible.parentElement;
    if (bidContainer && !bidContainer._mwyContObs) {
      bidContainer._mwyContObs = new MutationObserver(function() {
        var newVis = bidContainer.querySelector('span._a-current-bid-font:not(._a-hide)');
        if (newVis && !newVis._mwyObsInit) {
          newVis._mwyObsInit = true;
          initLabel(newVis);
          splitBidAmount(newVis);
          if (!newVis._mwyAmtObs) {
            newVis._mwyAmtObs = new MutationObserver(function() {
              newVis._mwyAmtObs.disconnect();
              initLabel(newVis);
              if (!newVis.querySelector('.mwy-amt')) splitBidAmount(newVis);
              else if (newVis.querySelector('#_a-current-bid:not(:has(.mwy-amt))')) splitBidAmount(newVis);
              newVis._mwyAmtObs.observe(newVis, { childList: true, subtree: true });
            });
            newVis._mwyAmtObs.observe(newVis, { childList: true, subtree: true });
          }
        }
      });
      bidContainer._mwyContObs.observe(bidContainer, { childList: true, subtree: true });
    }

    // 7. Hint
    function stripCents(t) { return t.split('.00').join(''); }
    var allDivs = document.querySelectorAll('#_a-auction-inputs-container div');
    var hintEl = null;
    for (var i = 0; i < allDivs.length; i++) { if (allDivs[i].textContent.indexOf('or more') > -1) { hintEl = allDivs[i]; break; } }
    if (hintEl) {
      hintEl.textContent = stripCents(hintEl.textContent);
      hintEl.classList.add('mwy-bid-hint');
      hintEl.style.setProperty('text-align', isMobile ? 'center' : 'left', 'important');
      hintEl.style.setProperty('margin-bottom', '10px', 'important');
      if (!hintEl._mwyDecObs) {
        hintEl._mwyDecObs = new MutationObserver(function() {
          if (hintEl.textContent.indexOf('.00') > -1) hintEl.textContent = stripCents(hintEl.textContent);
        });
        hintEl._mwyDecObs.observe(hintEl, { childList: true, characterData: true, subtree: true });
      }
    }

        // 8. End date
    var endEl = document.getElementById('_a-end-date');
    if (endEl && !endEl.getAttribute('data-date')) {
      var raw = endEl.textContent.trim();
      var isStart = /^start date:/i.test(raw);
      raw = raw.replace(/^(end|start) date:\s*/i, '');
      var dm = raw.match(/\w+,\s+(\w+ \d+,\s*\d{4})\s*[-–]\s*(\d+:\d+):\d+\s*(AM|PM)/i);
      if (dm) {
        endEl.setAttribute('data-date', dm[1] + ' · ' + dm[2] + ' ' + dm[3] + ' ET');
        if (isStart) {
          endEl.setAttribute('data-start-date', dm[1]);
        } else {
          endEl.setAttribute('data-end-date', dm[1]);
        }
      } else if (raw.length > 3) {
        endEl.setAttribute('data-date', raw);
      }
    }

    // 9. Countdown
    function fmtCt(t) { return t.replace(/([0-9]+)h/, '$1 hrs').replace(/([0-9]+)m/, '$1 mins').replace(/([0-9]+)s/, '$1 secs').trim(); }
    var ct = document.getElementById('_a-countdown-timer');
    if (ct) {
      if (ct.textContent.indexOf('h') > -1) ct.textContent = fmtCt(ct.textContent);
      if (!ct._mwyCtObs) {
        ct._mwyCtObs = new MutationObserver(function() {
          var t = ct.textContent.trim();
          if (t.indexOf('h') > -1 && t.indexOf('hrs') === -1) ct.textContent = fmtCt(t);
        });
        ct._mwyCtObs.observe(ct, { childList: true, characterData: true, subtree: true });
      }
    }

  }, 150);


  // ── Custom notice: intercepts AP errors & banners ────────────────────────
  (function initMwyNotice() {

    // Create and insert our notice element after the bid hint
    function getOrCreateNotice() {
      var el = document.querySelector('.mwy-notice');
      if (el) return el;
      el = document.createElement('div');
      el.className = 'mwy-notice';
      var hint = document.querySelector('#_a-auction-inputs-container .mwy-bid-hint');
      if (hint && hint.parentElement) {
        hint.parentElement.insertBefore(el, hint.nextSibling);
      }
      return el;
    }

    // Show notice with given HTML, then auto-fade after 10s
    function showNotice(html, type) {
      if (!html || !html.trim()) return;
      var el = getOrCreateNotice();
      if (el._fadeTimer) clearTimeout(el._fadeTimer);
      el.innerHTML = html;
      el.classList.remove('mwy-notice--error', 'mwy-notice--success');
      el.classList.add(type === 'success' ? 'mwy-notice--success' : 'mwy-notice--error');
      el.style.opacity = '1';
      el.style.display = 'block';
      el._fadeTimer = setTimeout(function() {
        el.style.opacity = '0';
        setTimeout(function() {
          el.style.display = 'none';
          el.style.opacity = '1';
          el._fadeTimer = null;
        }, 850);
      }, 10000);
    }

    // Watch #_a-error-message for when AP removes _a-hide → always an error
    var errDiv = document.querySelector('#_a-error-message');
    var errSpan = document.querySelector('#_a-error-message-span');
    if (errDiv && errSpan) {
      new MutationObserver(function() {
        if (!errDiv.classList.contains('_a-hide') && !errDiv.classList.contains('_a-display-none')) {
          var html = errSpan.innerHTML.trim();
          errDiv.classList.add('_a-hide');
          if (/must\s+(log\s*in|login)|login\s+or\s+create/i.test(html)) { html = '<a href="/account/login">Log in<\/a> to place a bid'; }
             showNotice(html, 'error');
        }
      }).observe(errDiv, { attributes: true, attributeFilter: ['class'] });
    }

    // Watch all AP banner divs; outbid = error, others = success
    var bannerTypes = {
      '_a-banner-div': 'success',
      '_a-banner-div-notification': 'success',
      '_a-banner-div-notification-outbid': 'error',
      '_a-banner-div-notification-alt': 'success'
    };
    Object.keys(bannerTypes).forEach(function(id) {
      var banner = document.getElementById(id);
      if (!banner) return;
      var type = bannerTypes[id];
      new MutationObserver(function() {
        if (!banner.classList.contains('_a-display-none')) {
          var msgEl = banner.querySelector('._a-banner-message, ._a-banner-text-notification');
          var html = msgEl ? msgEl.innerHTML.trim() : '';
          banner.classList.add('_a-display-none');
          if (html) showNotice(html, type);
        }
      }).observe(banner, { attributes: true, attributeFilter: ['class'] });
    });

  })();

})();


// ── Bid Confirm Modal: inject bid amount before display ───────────
(function initConfirmModal() {
  var modal = document.getElementById('_a-auction-modal-bid-confirm');
  if (!modal) return;
  var body = modal.querySelector('._a-modal-body');
  if (!body) return;

  function updateBody() {
    var input = document.querySelector('#_a-bid-input');
    var raw = input ? input.value.replace(/[^0-9.]/g, '') : '';
    var amt = raw ? '$' + parseFloat(raw).toLocaleString('en-US', {minimumFractionDigits: 0}) : '$—';
    body.innerHTML = '<span class="mwy-confirm-label">You are bidding</span>' +
                     '<span class="mwy-confirm-amount">' + amt + '</span>';
  }

  new MutationObserver(function() {
    if (!modal.classList.contains('_a-hidden-menu')) {
      updateBody();
    }
  }).observe(modal, { attributes: true, attributeFilter: ['class'] });
})();


// ── AP-ready init guard — ensures observers attach after AP elements exist ─────────
(function() {

  function runAPInit() {
    var errDiv  = document.getElementById('_a-error-message');
    var errSpan = document.getElementById('_a-error-message-span');
    var modal   = document.getElementById('_a-auction-modal-bid-confirm');
    if (!errDiv || !errSpan || !modal) return false;

    // Guard: only wire up once per element lifecycle
    if (errDiv._mwyInit) return true;
    errDiv._mwyInit = true;

    function getOrCreateNotice() {
      var el = document.querySelector('.mwy-notice');
      if (el) return el;
      el = document.createElement('div');
      el.className = 'mwy-notice';
      var hint = document.querySelector('#_a-auction-inputs-container .mwy-bid-hint');
      if (hint && hint.parentElement) hint.parentElement.insertBefore(el, hint.nextSibling);
      return el;
    }

    function showNotice(html, type) {
      if (!html || !html.trim()) return;
      var el = getOrCreateNotice();
      if (el._fadeTimer) clearTimeout(el._fadeTimer);
      el.innerHTML = html;
      el.classList.remove('mwy-notice--error', 'mwy-notice--success');
      el.classList.add(type === 'success' ? 'mwy-notice--success' : 'mwy-notice--error');
      el.style.opacity = '1';
      el.style.display = 'block';
      el._fadeTimer = setTimeout(function() {
        el.style.opacity = '0';
        setTimeout(function() {
          el.style.display = 'none';
          el.style.opacity = '1';
          el._fadeTimer = null;
        }, 850);
      }, 10000);
    }

    // Error message observer
    new MutationObserver(function() {
      if (!errDiv.classList.contains('_a-hide') && !errDiv.classList.contains('_a-display-none')) {
        var html = errSpan.innerHTML.trim();
        errDiv.classList.add('_a-hide');
        if (/must\s+(log\s*in|login)|login\s+or\s+create/i.test(html)) {
          html = '<a href="/account/login">Log in<\/a> to place a bid';
        }
        showNotice(html, 'error');
      }
    }).observe(errDiv, { attributes: true, attributeFilter: ['class'] });

    // Banner observers
    var bannerTypes = {
      '_a-banner-div': 'success',
      '_a-banner-div-notification': 'success',
      '_a-banner-div-notification-outbid': 'error',
      '_a-banner-div-notification-alt': 'success'
    };
    Object.keys(bannerTypes).forEach(function(id) {
      var banner = document.getElementById(id);
      if (!banner) return;
      var bType = bannerTypes[id];
      new MutationObserver(function() {
        if (!banner.classList.contains('_a-display-none')) {
          var msgEl = banner.querySelector('._a-banner-message, ._a-banner-text-notification');
          var html = msgEl ? msgEl.innerHTML.trim() : '';
          banner.classList.add('_a-display-none');
          if (html) showNotice(html, bType);
        }
      }).observe(banner, { attributes: true, attributeFilter: ['class'] });
    });

    // Confirm modal: inject bid amount before display
    var body = modal.querySelector('._a-modal-body');
    if (body) {
      function updateBody() {
        var input = document.getElementById('_a-bid-input');
        var raw = input ? input.value.replace(/[^0-9.]/g, '') : '';
        var amt = raw ? '$' + parseFloat(raw).toLocaleString('en-US', {minimumFractionDigits: 0}) : '$—';
        body.innerHTML = '<span class="mwy-confirm-label">You are bidding<\/span>' +
                         '<span class="mwy-confirm-amount">' + amt + '<\/span>';
      }
      new MutationObserver(function() {
        if (!modal.classList.contains('_a-hidden-menu')) updateBody();
      }).observe(modal, { attributes: true, attributeFilter: ['class'] });
    }

    return true;
  }

  // Try immediately — AP may already be loaded on a warm page
  if (!runAPInit()) {
    var _mwyPoll = setInterval(function() {
      if (runAPInit()) clearInterval(_mwyPoll);
    }, 200);
    setTimeout(function() { clearInterval(_mwyPoll); }, 15000);
  }

})();


/* ============================================
   STORE MENU — toggle .menu-open on parent
   ============================================ */
(function() {
  var wrapper = document.querySelector('.store-menu-mobile');
  if (!wrapper) return;
  var observer = new MutationObserver(function() {
    var dropdown = wrapper.querySelector('.dropdown-menu');
    if (dropdown && dropdown.classList.contains('is-open')) {
      wrapper.classList.add('menu-open');
    } else {
      wrapper.classList.remove('menu-open');
    }
  });
  var dropdown = wrapper.querySelector('.dropdown-menu');
  if (dropdown) {
    observer.observe(dropdown, { attributes: true, attributeFilter: ['class'] });
  }
})();

/* Store category rows never wrap. Check real rendered width only when layout
   or content changes, not on scroll; ruler padding is not part of this test. */
(function () {
  var records = new Map();
  var widths = new WeakMap();
  var frame = 0;
  var desktop = window.matchMedia('(min-width: 601px)');
  var observer = 'ResizeObserver' in window ? new ResizeObserver(function (entries) {
    var changed = false;
    entries.forEach(function (entry) {
      var width = entry.contentRect.width;
      if (widths.get(entry.target) !== width) {
        widths.set(entry.target, width);
        changed = true;
      }
    });
    if (changed) schedule();
  }) : null;

  function measure() {
    frame = 0;
    var updates = [];
    records.forEach(function (record, root) {
      if (!root.isConnected) return;
      var available = root.getBoundingClientRect().width;
      var required = record.row.getBoundingClientRect().width;
      // Phone compact layouts remain CSS-owned. A hidden
      // desktop row is remeasured when its breakpoint makes it visible again.
      var overflow = desktop.matches && available > 0 && required > available + 0.5;
      if (root.classList.contains('mwy-store-nav--overflow') !== overflow) {
        updates.push({ root:root, overflow:overflow, record:record });
      }
    });
    // Complete all reads before changing a header's layout.
    updates.forEach(function (update) {
      update.root.classList.toggle('mwy-store-nav--overflow', update.overflow);
      if (!update.overflow) {
        var mobile = update.record.mobile;
        var trigger = mobile.querySelector('.dropdown-trigger');
        var dropdown = mobile.querySelector('.dropdown-menu');
        if (trigger) trigger.setAttribute('aria-expanded', 'false');
        if (dropdown) dropdown.classList.remove('is-open');
        mobile.classList.remove('menu-open');
      }
    });
  }
  function schedule() {
    if (!frame) frame = requestAnimationFrame(measure);
  }
  function scan(scope) {
    scope.querySelectorAll('.mwy-store-navigation').forEach(function (root) {
      if (records.has(root)) return;
      var row = root.querySelector('.store-menu__links');
      var mobile = root.querySelector('.store-menu-mobile');
      if (!row || !mobile) return;
      var contentObserver = new MutationObserver(schedule);
      contentObserver.observe(row, { childList:true, subtree:true, characterData:true });
      records.set(root, { row:row, mobile:mobile, contentObserver:contentObserver });
      if (observer) { observer.observe(root); observer.observe(row); }
    });
    schedule();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { scan(document); }, { once:true });
  } else scan(document);
  window.addEventListener('resize', schedule, { passive:true });
  if (document.fonts) document.fonts.ready.then(schedule);
  document.addEventListener('shopify:section:load', function (event) { scan(event.target); });
  document.addEventListener('shopify:section:unload', function (event) {
    records.forEach(function (record, root) {
      if (!event.target.contains(root)) return;
      record.contentObserver.disconnect();
      if (observer) { observer.unobserve(root); observer.unobserve(record.row); }
      records.delete(root);
    });
  });
})();

/* Repair editor-generated span wrappers around description list items.
   The component owns typography; retain links/emphasis inside each item. */
(function () {
  function normalizeDescriptions(root) {
    root.querySelectorAll('.product-block--description .rte ul > span, .product-block--description .rte ol > span').forEach(function (wrapper) {
      if (!wrapper.querySelector('li')) return;
      wrapper.replaceWith.apply(wrapper, Array.from(wrapper.childNodes));
    });
    root.querySelectorAll('.product-block--description > .rte').forEach(function (box) {
      // Editor spacer paragraphs are not description content. Remove only
      // empty edge blocks, preserving deliberate breaks within the copy.
      function empty(node) {
        return node && !node.textContent.trim() && !node.querySelector('img, video, iframe, svg, input, table');
      }
      while (empty(box.lastElementChild)) box.lastElementChild.remove();
      while (empty(box.firstElementChild)) box.firstElementChild.remove();
      box.querySelectorAll('.mwy-description-first, .mwy-description-last').forEach(function (node) {
        node.classList.remove('mwy-description-first', 'mwy-description-last');
      });
      var lines = Array.from(box.querySelectorAll('li, p, h1, h2, h3, h4, h5, h6, div')).filter(function (node) {
        return node.textContent.trim() && !node.querySelector('li, p, h1, h2, h3, h4, h5, h6, div');
      });
      if (lines.length) {
        lines[0].classList.add('mwy-description-first');
        lines[lines.length - 1].classList.add('mwy-description-last');
      }
    });
  }
  normalizeDescriptions(document);
  document.addEventListener('shopify:section:load', function (event) {
    normalizeDescriptions(event.target);
  });
})();

/* Tablet descriptions belong below BOTH product columns, above the release
   tabs. Move the existing block, never clone it: editor identity, links and
   listeners are preserved. Only breakpoint changes cause layout writes. */
(function () {
  if (!document.body.classList.contains('template-product')) return;
  var tablet = window.matchMedia('(min-width:601px) and (max-width:1024px), (min-width:601px) and (max-width:1366px) and (hover:none) and (pointer:coarse)');
  var records = new Map();

  function update(record) {
    record.blocks.forEach(function (entry) {
      if (tablet.matches) {
        if (entry.block.parentNode !== record.slot) record.slot.appendChild(entry.block);
      } else if (entry.anchor.parentNode && entry.block.previousSibling !== entry.anchor) {
        entry.anchor.after(entry.block);
      }
    });
    record.slot.hidden = !tablet.matches;
  }
  function scan(scope) {
    scope.querySelectorAll('.product-section[data-history="true"]').forEach(function (root) {
      if (records.has(root)) return;
      var grid = root.querySelector(':scope > .page-content > .page-width > .grid');
      if (!grid) return;
      var blocks = Array.from(grid.querySelectorAll('.product-single__meta .product-block--description'));
      if (!blocks.length) return;
      var slot = document.createElement('div');
      slot.className = 'mwy-tablet-description';
      slot.hidden = true;
      grid.after(slot);
      var record = { slot:slot, blocks:blocks.map(function (block) {
        var anchor = document.createComment('Product description original position');
        block.before(anchor);
        return { block:block, anchor:anchor };
      }) };
      records.set(root, record);
      update(record);
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { scan(document); }, { once:true });
  } else scan(document);
  tablet.addEventListener('change', function () { records.forEach(update); });
  document.addEventListener('shopify:section:load', function (event) { scan(event.target); });
  document.addEventListener('shopify:section:unload', function (event) {
    records.forEach(function (record, root) {
      if (!event.target.contains(root)) return;
      record.blocks.forEach(function (entry) {
        if (entry.anchor.parentNode) entry.anchor.replaceWith(entry.block);
      });
      record.slot.remove();
      records.delete(root);
    });
  });
})();

/* Touch feedback follows the actual pointer, including hybrid tablets. */
(function () {
  var pressed;
  function clear() {
    if (pressed) pressed.classList.remove('mwy-card-touch-pressed');
    pressed = null;
  }
  function press(event) {
    if (event.pointerType !== 'touch' && event.pointerType !== 'pen') return;
    clear();
    var link = event.target.closest && event.target.closest('#MainContent .grid-product__link, #MainContent .mwy-store-featured__product-link');
    if (!link) return;
    pressed = link;
    link.classList.add('mwy-card-touch-pressed');
  }
  document.addEventListener('pointerdown', press, { passive:true });
  document.addEventListener('pointerup', clear, { passive:true });
  document.addEventListener('pointercancel', clear, { passive:true });
  window.addEventListener('blur', clear);
  window.addEventListener('pageshow', clear);
})();

/* Measure only the independent basket button: never a checkout ancestor
   whose height includes the row we are sizing. Description spacing is CSS-owned. */
(function () {
  var frame;
  function update() {
    document.querySelectorAll('.shopify-payment-button__more-options').forEach(function (link) {
      var payment = link.closest('.shopify-payment-button');
      if (!payment) return;
      var row = link.closest('.mwy-payment-options-row');
      if (!row) {
        row = document.createElement('div');
        row.className = 'mwy-payment-options-row';
        link.before(row);
        row.appendChild(link);
      }
      var form = payment.closest('form');
      var button = form && form.querySelector('.add-to-cart');
      if (button && button.getBoundingClientRect().height) {
        row.style.setProperty('--mwy-payment-row-height', button.getBoundingClientRect().height + 'px');
      }
      row.style.setProperty('--mwy-payment-row-gap', getComputedStyle(payment).marginTop);
    });
  }
  function schedule() { cancelAnimationFrame(frame); frame = requestAnimationFrame(update); }
  schedule();
  if (document.fonts) document.fonts.ready.then(schedule);
  window.addEventListener('resize', schedule);
  window.addEventListener('load', schedule);
  document.addEventListener('shopify:section:load', schedule);
  new MutationObserver(function (records) {
    if (records.some(function (record) { return Array.from(record.addedNodes).some(function (node) {
      return node.nodeType === 1 && (node.matches('.shopify-payment-button__more-options, shopify-accelerated-checkout') || node.querySelector('.shopify-payment-button__more-options'));
    }); })) schedule();
  }).observe(document.body, { childList:true, subtree:true });
})();
